export const SubscriptionStatus = Object.freeze({
  AUTHORIZED: "authorized",
  PENDING: "pending",
  PAUSED: "paused",
  CANCELLED: "cancelled",
});

export const SubscriptionStatusLabels = {
  [SubscriptionStatus.AUTHORIZED]: "Activo",
  [SubscriptionStatus.PENDING]: "Pendiente",
  [SubscriptionStatus.PAUSED]: "Pausado",
  [SubscriptionStatus.CANCELLED]: "Cancelado",
};

export const FrecuencyTypes = Object.freeze({
  MONTHLY: "months",
  YEARLY: "years",
});

export const FrecuencyTypeLabels = {
  [FrecuencyTypes.MONTHLY]: "Mensual",
  [FrecuencyTypes.YEARLY]: "Anual",
};
